import React from 'react';
import * as Yup from 'yup';
import { Formik, Field, FieldProps, FormikHelpers } from 'formik';
import { Spin, Input, Button } from 'antd';
import { FormField } from '../../components/FormField';

const validationSchema = Yup.object({
  password: Yup.string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$*.{}?"!@#%&/,><':;|_~`^\][)(]).+/,
      'Your password should contain at least 1 uppercase letter, lowercase letter, number and symbol'
    )
    .min(6, 'Your password should be at least 6 characters long')
    .required('Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Passwords must match'),
});

type FormValues = { password: string; confirmPassword: string };
type Props = {
  onSubmit: (values: FormValues, actions: FormikHelpers<FormValues>) => any;
};

export const NewPasswordForm = ({ onSubmit }: Props) => {
  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={{ password: '', confirmPassword: '' }}
      validationSchema={validationSchema}>
      {({ isSubmitting, handleSubmit }) => (
        <div style={{ display: 'flex', flexDirection: 'column', padding: '8px 0 0 0' }}>
          <form onSubmit={handleSubmit}>
            <Field name="password">
              {(props: FieldProps) => (
                <FormField {...props}>
                  <Input.Password size="large" placeholder="Password" {...props.field} />
                </FormField>
              )}
            </Field>

            <Field name="confirmPassword">
              {(props: FieldProps) => (
                <FormField {...props}>
                  <Input.Password size="large" placeholder="Confirm password" {...props.field} />
                </FormField>
              )}
            </Field>

            {isSubmitting ? (
              <div style={{ display: 'flex', justifyContent: 'center', padding: '0' }}>
                <Spin />
              </div>
            ) : (
              <div style={{ padding: '0' }}>
                <Button
                  style={{ width: '100%' }}
                  size="large"
                  type="primary"
                  htmlType="submit"
                  className="login-form-button">
                  Confirm
                </Button>
              </div>
            )}
          </form>
        </div>
      )}
    </Formik>
  );
};
